/**
 * useUnreadAlerts — tiny shared hook for the bottom-nav alert dot.
 *
 * Polls /api/alerts/unread-count every 60s so the dot is "live enough" without
 * hammering the engine (compute_alerts is cheap but still does a Mongo fan-out
 * to 6 collections). Components consume the hook in their nav button and
 * render the AlertDot.
 *
 * Returns `{ total, high, medium, low, loading }`.
 */
import { useEffect, useState } from 'react';
import { API_URL } from '../config/api';

const POLL_MS = 60_000;

export function useUnreadAlerts() {
  const [counts, setCounts] = useState({ total: 0, high: 0, medium: 0, low: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    let timer;
    const fetchCounts = async () => {
      try {
        const r = await fetch(`${API_URL}/api/alerts/unread-count`, {
          credentials: 'include',
        });
        if (!r.ok) return;
        const j = await r.json();
        if (live) setCounts({
          total:  j.total  || 0,
          high:   j.high   || 0,
          medium: j.medium || 0,
          low:    j.low    || 0,
        });
      } catch {
        // Silent — anonymous users hit 401, that's fine.
      } finally {
        if (live) setLoading(false);
      }
    };
    fetchCounts();
    timer = setInterval(fetchCounts, POLL_MS);
    return () => { live = false; clearInterval(timer); };
  }, []);

  return { ...counts, loading };
}
